<template>
    <div style="display: flex;flex-direction: column;
    height: 100%;
    ">
        <div style="width: 100%;overflow: auto;  scrollbar-width: none;
  -ms-overflow-style: none;display: flex;align-items: center; ">
            <div class="columnformat">
                <div
                    style="display: flex;flex-direction: column;align-items: center;width: 90%;background:white;border-radius: 10px;box-shadow: 0 0 15px 5px rgba(200, 200, 200, 0.5);">
                    <div
                        style="width: calc(100% - 10px);text-align: left;padding-left: 10px;padding-top: 10px;padding-bottom: 10px;background:#FFE988;font-weight: 700;">
                        < 花花美社 </div>


                    </div>
                </div>
            </div>
        </div>
</template>

<style scoped>
.columnformat {

    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
    background: #F0F5F4;
    overflow: auto;
}
</style>

<script>
import request from "../axios/request";
export default {
    data() {
        return {
            typeId: null,
            businessList: []
        }
    },
    mounted() {
        this.typeId = this.$route.params.typeId;
        this.getTypeBusinessList()
    },
    methods: {
        async getTypeBusinessList() {
            let res = await request({
                url: "/business/api/getTypeBusinessList",
                method: "GET"
            })
            if (res.data.status == 200) {
                this.businessList = res.data.data
            }
        }
    }
}
</script>